export default {
  superAdmin: "SUPER_ADMIN",
  admin: "ADMIN",
  client: "CLIENT"
}



// WEBPACK FOOTER //
// ./src/models/Roles.js